/**
 * Post-login/signup redirect for end users (`role === "user"`).
 *
 * `sessionStorage.redirectPath` is set from whatever URL triggered auth (see RequireAuth).
 * If a user hit /login or /signup after trying to open an admin-only route (e.g. /layouts),
 * we must not send them there after signup — they should land on /main instead.
 */

function pathMatchesPrefix(path, prefix) {
  return path === prefix || path.startsWith(`${prefix}/`);
}

/**
 * Returns a safe path for a normal end user after login or signup.
 * @param {string | null | undefined} redirectPath — value from sessionStorage
 * @returns {string}
 */
export function getSafeUserPostAuthDestination(redirectPath) {
  const path = (redirectPath || "").trim();
  if (!path) return "/main";

  // Explicit user / app flows — preserve deep links
  if (pathMatchesPrefix(path, "/main")) return "/main";
  if (pathMatchesPrefix(path, "/floor-plan")) return path;
  if (pathMatchesPrefix(path, "/floor-gallery")) return path;
  if (pathMatchesPrefix(path, "/upload-floor")) return path;
  if (pathMatchesPrefix(path, "/layout")) return path;
  if (pathMatchesPrefix(path, "/gallery")) return path;
  if (pathMatchesPrefix(path, "/edit")) return path;
  if (pathMatchesPrefix(path, "/forgetPsw")) return path;
  if (pathMatchesPrefix(path, "/external-ai-upload")) return path;
  if (pathMatchesPrefix(path, "/partner-login")) return path;

  // Anything else (/, /layouts, /partners, /users, /floorPlans, …) → user home
  return "/main";
}
